import { IoEyeOutline, IoEyeOffOutline } from 'react-icons/io5'
import { useItemPage } from '@components/ItemPage/Layout/ItemPageContext'
import React, { useContext } from 'react'
import { AuthContext } from '../../../../../contexts/AuthContext'
import classNames from 'classnames'

const Watchlist = () => {
  const { isLoading, isAuthenticated } = useContext<any>(AuthContext)
  const {
    itemState: { addedToWatchlist, itemClosed },
    itemHandler: { toggleWatchlist },
  } = useItemPage()

  if (isLoading)
    return (
      <div className={'animate-pulse w-full h-11 bg-slate-400 rounded-md'} />
    )

  const isDisabled = !isAuthenticated || (itemClosed && !addedToWatchlist)

  const activeClass =
    'bg-white hover:text-bidfta-blue-light hover:border-bidfta-blue-light hover:bg-gray-100 transition duration-200 border-bidfta-blue-backdrop-light text-bidfta-blue-backdrop-light '

  const disabledClass = 'bg-gray-200 text-gray-400'

  return (
    <button
      disabled={isDisabled}
      onClick={toggleWatchlist}
      className={classNames(
        ' border text-18 rounded py-3 px-4 font-semibold flex items-center justify-center gap-2',
        isDisabled ? disabledClass : activeClass
      )}
    >
      {addedToWatchlist ? (
        <IoEyeOffOutline size={24} />
      ) : (
        <IoEyeOutline size={24} />
      )}

      {addedToWatchlist ? 'Remove from Watchlist' : 'Add to Watchlist'}
    </button>
  )
}

export default Watchlist
